<div *ngIf="LgvClientSvc.IsSSLoading$ | async">
    <lgv-loading-indicator></lgv-loading-indicator>
</div>
<lgv-loading-indicator *ngIf="IsLoading$ | async"></lgv-loading-indicator>

<!--#region Warnings-->
<ng-template #MissingLoanAnaysis>
    <div class="alert alert-warning">Missing loan analysis...</div>
</ng-template>

<ng-template #missingLoanInfo>
    <div class="alert alert-warning">Missing essential loan information...</div>
</ng-template>

<ng-template #missingSnapshot>
    <div class="alert alert-warning">Missing essential client data...</div>
</ng-template>
<!--#endregion Warnings-->

<!--Complete SS-->
<div id="complete" *ngIf="LgvClientSvc.IsSSReady$ | async">

    <div class="container" rtl *ngIf="SS$ | async as SS">

        <lgv-agent-onboarding-banner *ngIf="LgvAPI.ShowOnboardingBanner$ | async"></lgv-agent-onboarding-banner>

        <!--#region Client Details-->
        <div class="alert alert-info" *ngIf="CoBrandingPartner$ | async as partner">
            <div style="padding:15px;">
                Co-branding Agent: <b>{{partner.agentInfo.firstName}} {{partner.agentInfo.lastName}}</b>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <mat-card>

                    <div class="row">
                        <div class="col-12">
                            <div class="float-left">
                                <h2 *ngIf="SS.clientInfo">{{SS.clientInfo.firstName}} {{SS.clientInfo.lastName}}</h2>
                            </div>

                            <div class="float-end ellipsisMenuWrapper">
                                <button mat-button [matMenuTriggerFor]="LoanActionMenu">
                                    <fa-icon style="font-size:18px;" icon="bars"></fa-icon>
                                </button>
                                <mat-menu #LoanActionMenu="matMenu">
                                    <div class="ellipsisMenuContent">
                                        <button mat-menu-item (click)="OnGoToClientView(SS.clientInfo.ownerId)"><fa-icon
                                                icon="chart-line"></fa-icon>&nbsp;&nbsp; Dashboard</button>
                                        <button mat-menu-item (click)="SendClientInvitation(SS.clientInfo.id)"
                                            *ngIf="LgvUserSvc.IsAnyAdmin"><fa-icon
                                                icon="paper-plane"></fa-icon>&nbsp;&nbsp; Send Client Report</button>
                                        <button *ngIf="!SS.clientInfo.isSilenced" mat-menu-item
                                            (click)="OnConfirmSilenceClient(SS.clientInfo, true)"><fa-icon
                                                icon="ban"></fa-icon>&nbsp;&nbsp; Make Inactive</button>
                                        <button *ngIf="SS.clientInfo.isSilenced" mat-menu-item
                                            (click)="OnConfirmSilenceClient(SS.clientInfo, false)"><fa-icon
                                                icon="plus"></fa-icon>&nbsp;&nbsp; Make Active</button>
                                        <button mat-menu-item (click)="onGenerateClientToken(SS.clientInfo.id)"
                                            title="Generate a login link for this client"><fa-icon
                                                icon="share"></fa-icon>&nbsp;&nbsp; Share Login Link</button>
                                        <button mat-menu-item (click)="onOpenAddPropertyModal()"
                                            title="Add Property"><fa-icon icon="plus"></fa-icon>&nbsp;&nbsp; Add
                                            Property</button>
                                        <button mat-menu-item (click)="onStartLoanFile()"><fa-icon
                                                icon="landmark"></fa-icon>&nbsp;&nbsp; Start Loan File</button>

                                    </div>

                                </mat-menu>
                            </div>
                            <div class="clear-both"></div>

                        </div>
                        <div class="Vert-10 col-12"></div>
                        <div class="col-xl-5 col-sm-12">
                            <div><span class="standOutText5">Contact Information</span>&nbsp;&nbsp;<a
                                    (click)="onEditContactInformation(SS.clientInfo)"><b>Edit</b></a></div>
                            <div class="Vert-10"></div>
                            <table style="width:100%;">
                                <tr>
                                    <td class="labelName">Email:</td>
                                    <td class="labelValue"><a
                                            [ngClass]="SS.clientInfo?.email.length > 30 ? 'small-text' : '' "
                                            (click)="onEmailClient()">{{SS.clientInfo.email}}</a></td>
                                </tr>
                                <tr>
                                    <td class="labelName">Cell Phone:</td>
                                    <td class="labelValue">{{SS.clientInfo.mobilePhone | LgvPhoneNumber}}</td>
                                </tr>
                                <tr *ngIf="LgvClientSvc.primaryProperty$ | async as primaryProperty">
                                    <td class="labelName">Primary Property:</td>
                                    <td class="labelValue">{{primaryProperty.propertyInfo.address}}</td>
                                </tr>
                            </table>

                        </div>
                        <div class="col-xl-3 col-sm-12">
                            <div><span class="standOutText5">Financial Details</span>&nbsp;&nbsp;<a
                                    (click)="onEditFinancialDetails(SS.clientInfo)"><b>Edit</b></a></div>
                            <div class="Vert-10"></div>
                            <table>
                                <tr *ngIf="SS.clientInfo.totalIncome">
                                    <td class="labelName">Monthly Income:</td>
                                    <td class="labelValue">{{SS.clientInfo.totalIncome | number : '1.0-0'}}</td>
                                </tr>
                                <tr *ngIf="SS.clientInfo.totalDebtPayments">
                                    <td class="labelName">Monthly Debts:</td>
                                    <td class="labelValue">{{SS.clientInfo.totalDebtPayments | number : '1.0-0'}}</td>
                                </tr>
                                <tr *ngIf="LgvClientSvc.calcDTI$ | async as dti">
                                    <td class="labelName">DTI:</td>
                                    <td class="labelValue">{{dti}}</td>
                                </tr>
                                <tr *ngIf="SS.clientInfo.fico">
                                    <td class="labelName">FICO:</td>
                                    <td class="labelValue">{{SS.clientInfo.fico | number : '1.0-0'}}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="col-xl-4 col-sm-12">
                            <table>
                                <tr>
                                    <td class="labelName" style="vertical-align:top;">Selected Goals:</td>
                                    <td class="labelValue">

                                        <ng-container *ngIf="ClientGoals$|async as goals">
                                            <ng-container *ngFor="let g of goals">
                                                <div>{{g.description}}</div>
                                            </ng-container>
                                            <div *ngIf="goals?.length === 0">
                                                None Selected
                                            </div>
                                        </ng-container>

                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="Vert-15"></div>
                            <div class="float-start">
                                <button class="btn white skinny" (click)="onViewClientEmails()"><fa-icon icon="envelope-open"></fa-icon>&nbsp;&nbsp;View Client Emails</button>
                            </div>
                            <div class="float-start Lt-Marg-15">
                                <button class="btn white skinny" (click)="onEmailClient()"><fa-icon icon="envelope"></fa-icon>&nbsp;&nbsp;Email Client</button>
                            </div>
                            <div style="clear:both"></div>
                        </div>
                    </div>

                </mat-card>
            </div>
        </div>

        <!-- PricingScenarios for Propertyless-->
        <div class="row" *ngIf="LgvClientSvc.isPropertyless$ | async">
            <div class="col-12">
                <mat-card>
                    <lgv-pricing-scenario-viewer *ngIf="LgvUserSvc.AgentSS$ | async as agentSS"
                        [pricingScenarios$]="LgvClientSvc.propertylessScenarios$"
                        [isPropertyless]="false"
                        [clientID]="ClientIDParam" 
                        [opportunities$]="LgvClientSvc.allOpportunities$"
                        [agentSS]="agentSS"></lgv-pricing-scenario-viewer>
                </mat-card>
            </div>
        </div>

        <!-- <lus-prospect-property-status *ngIf="(LgvClientSvc.prospectProperties$ | async)?.length > 0"
            (goToDashboard)="OnGoToClientView(SS.clientInfo.ownerId)"></lus-prospect-property-status>
        <div class="divider-company-color"></div> -->


        <div *ngIf="(LgvClientSvc.ClientProperties$ | async)?.length > 0">
            <div class="Vert-20"></div>
            <button *ngIf="LgvClientSvc.isOwner$ | async" (click)="togglePropertyList('Owned')"
                [ngClass]="(showingPropertyType$ | async) === 'Owned' && !!(LgvClientSvc.SelectedProperty$ | async) ? 'btn btn-primary' : 'btn btn-secondary' ">Owned
                Properties</button>&nbsp;&nbsp;
            <button *ngIf="LgvClientSvc.isBuyer$ | async" (click)="togglePropertyList('Prospect')"
                [ngClass]="(showingPropertyType$ | async) === 'Prospect' && !!(LgvClientSvc.SelectedProperty$ | async) ? 'btn btn-primary' : 'btn btn-secondary' ">Prospect
                Properties</button>&nbsp;&nbsp;
            <button *ngIf="!(LgvClientSvc.isPropertyless$ | async)" (click)="togglePropertyList('Propertyless')"
                [ngClass]="(showingPropertyType$ | async) === 'Propertyless' || !(LgvClientSvc.SelectedProperty$ | async) ? 'btn btn-primary' : 'btn btn-secondary' ">Propertyless Scenarios</button>

            <div class="Vert-15"></div>
            <div *ngIf="(showingPropertyType$ | async) !== 'Propertyless'">
                <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                    (change)="OnSelectedPropertyChanged()" [(ngModel)]="RadioButton_SelectedProperty">
                    <mat-radio-button class="example-radio-button" style="padding-right:15px;"
                        *ngFor="let p of propertyList$ | async" [value]="p">
                        {{p.propertyInfo.address}}
                    </mat-radio-button>
                </mat-radio-group>

            </div>
        </div>

        <!--Selected Property-->
        <ng-container *ngIf="LgvClientSvc.SelectedProperty$ | async as property">
            <div class="Vert-10"></div>

            <div class="row">
                <div class="col-12">
                    <lus-property-detail-card [property]="property" [showPublicRecordData]="ShowPublicRecordData"
                        [activeLoans]="ActiveLoansForProperty$ | async"
                        [inactiveLoans]="InactiveLoansForProperty$ | async"
                        [publicRecordsSearchList]="PublicRecordSearchList$ | async"
                        [prospectLoanOpportunities]="opportunitiesforProspectProperty$ | async"
                        [clientIdParam]="ClientIDParam"
                        (openEditLoanDialog)="OpenEditLoanDialog($event)"
                        (loadRefiOpportunities)="onLoadLoanSenarioOpportunities(property, $event)"
                        (goToDashboard)="OnGoToClientView(SS.clientInfo.ownerId)"
                        (goToCreateLoan)="OnGoToCreateLoan($event)"
                        (loadProspectLoanOpportunities)="onLoadLoanSenarioOpportunities(property, $event)"
                        (editLoanScenario)="onEditLoanScenario($event)">
                    </lus-property-detail-card>
                </div>
                <!--<div class="col-12" *ngIf="property.associationType === 'Prospect'">
                    <lus-property-detail-card [property]="property"
                        [showPublicRecordData]="ShowPublicRecordData"
                        [publicRecordsSearchList]="PublicRecordSearchList$ | async"
                        (publicRecordLookup)="onDTLookupByProperty($event, false)"
                        (viewPublicRecord)="onViewPublicRecord($event, false)"
                        (openEditLoanDialog)="OpenEditLoanDialog()"></lus-property-detail-card>

                </div>-->

            </div>
        </ng-container>

        <!-- This would show if Propertyless Scenarios button is clicked -->
        <div class="row" *ngIf="((showingPropertyType$ | async) === 'Propertyless' && !(LgvClientSvc.isPropertyless$ | async)) && !(LgvClientSvc.SelectedProperty$ | async)">
                <div class="col-12">
                    <mat-card>
                        <lgv-pricing-scenario-viewer *ngIf="LgvUserSvc.AgentSS$ | async as agentSS" [clientID]="ClientIDParam"
                            [pricingScenarios$]="LgvClientSvc.propertylessScenarios$" [isPropertyless]="true"
                            [opportunities$]="LgvClientSvc.allOpportunities$"
                            [agentSS]="agentSS"></lgv-pricing-scenario-viewer>
                    </mat-card>
                </div>
        </div>

        <!--#region Previously Owned Properties-->
        <div class="row" *ngIf="LgvClientSvc.previouslyOwnedProperties$ | async as previouslyOwnedProperties">
            <div class="col-lg-12 col-sm-12" *ngIf="previouslyOwnedProperties?.length > 0">
                <h4>Previously Owned Properties</h4>
                <mat-card>
                    <p *ngFor="let p of previouslyOwnedProperties">
                        {{p.propertyInfo.address}}, {{p.propertyInfo.city}}, {{p.propertyInfo.state}}
                        {{p.propertyInfo.zip}}
                    </p>
                </mat-card>

            </div>
        </div>
        <!--#endregion Previously Owned Properties-->

        <!--#region Activities-->

        <div class="row">

            <div class="Vert-30 col-md-12"></div>

            <div class="col-lg-12 col-sm-12">

                <h4 style="font-family: Roboto; margin-left: 5px;">Activities</h4>

                <mat-card>
                    <table class='table table-striped'>
                        <thead>
                            <tr>
                                <th>
                                    <lgv-grid-header [HeaderText]="'Activity Type'" [SortField]="'activityTypeName'"
                                        [Mgr]="GridMgr"></lgv-grid-header>
                                </th>
                                <th>
                                    <lgv-grid-header [HeaderText]="'Date'" [SortField]="'activityTimestamp'"
                                        [Mgr]="GridMgr"></lgv-grid-header>
                                </th>
                                <th>
                                    <lgv-grid-header [HeaderText]="'Notes'" [SortField]="'Notes'" [Mgr]="GridMgr">
                                    </lgv-grid-header>
                                </th>
                            </tr>
                        </thead>
                        <tbody *ngIf="Activities$ | async as Activities">
                            <tr *ngFor="let x of Activities">
                                <td>{{x.activityTypeName}}</td>
                                <td>{{x.activityTimestamp | LgvUTCDate | date: 'short' }}</td>
                                <td>{{x.notes}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <lgv-grid-pager *ngIf="(Activities$ | async)?.length>0" [GridMgr]="GridMgr"></lgv-grid-pager>
                </mat-card>
            </div>
        </div>

        <!--#endregion Activities-->

    </div>

</div>
